// extracted by mini-css-extract-plugin
export default {"card":"StaffTimeTable_card__XdgbU","row":"StaffTimeTable_row__BULlC","icon":"StaffTimeTable_icon__LuNNg"};